import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useNavigate } from "react-router-dom";
import api from "../utils/api"; 
import { toast } from "react-toastify";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(16px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const Wrap = styled.div`
  padding: 2rem;
  margin-top: 70px;
  min-height: 100vh;
  background: linear-gradient(135deg, #fff7ed, #fff9f2);
  animation: ${fadeUp} 0.5s ease forwards;
`;

const Title = styled.h2`
  font-size: 1.6rem;
  color: #1f2937;
  margin-bottom: 0.4rem;
`;

const Accent = styled.div`
  width: 52px;
  height: 6px;
  border-radius: 99px;
  margin-bottom: 1.5rem;
  background: linear-gradient(90deg, rgba(249,115,22,1), rgba(255,186,87,1));
`;

const List = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
`;

const Card = styled.div`
  background: linear-gradient(180deg, rgba(255,255,255,0.98), #ffffff);
  border: 1px solid rgba(249,115,22,0.08);
  border-radius: 14px;
  padding: 1.25rem;
  box-shadow: 0 12px 26px rgba(249,115,22,0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  animation: ${fadeUp} 0.5s ease both;
  cursor: pointer;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 16px 38px rgba(249,115,22,0.1);
  }
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 1.05rem;
  color: #111827;
  margin-bottom: 6px;
`;

const Email = styled.div`
  color: #374151;
  font-size: 0.92rem;
  margin-bottom: 4px;
`;

const Role = styled.div`
  font-size: 0.85rem;
  color: #6b7280;
  background: rgba(249,115,22,0.08);
  border-radius: 6px;
  display: inline-block;
  padding: 3px 10px;
  font-weight: 600;
`;

const Empty = styled.div`
  text-align: center;
  color: #6b7280;
  margin-top: 2rem;
  font-style: italic;
`;

const Users = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get("/api/dataanalysis/surveyors"); 
        if (res.data.success) {
          setUsers(res.data.data);
        } else {
          toast.warn("Unexpected response format");
        }
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  return (
    <Wrap>
      <Title>Users</Title>
      <Accent />

      {loading ? (
        <Empty>Loading users...</Empty>
      ) : users.length === 0 ? (
        <Empty>No users found.</Empty>
      ) : (
        <List>
          {users.map((u) => (
            <Card key={u._id} onClick={() => navigate(`/users/${u._id}`)}>
              <Name>{u.name || "Unnamed User"}</Name>
              <Email>{u.email || "No email"}</Email>
              <Role>{u.role || "User"}</Role>
            </Card>
          ))}
        </List>
      )}
    </Wrap>
  );
};

export default Users;
